module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "height-100"
  }, [_c('div', {
    staticClass: "box"
  }, [_c('div', {
    staticClass: "title"
  }, [_vm._v("Documentos importantes")]), (_vm.lista.length === 0 && !_vm.isLoading) ? _c('div', [_vm._m(0)]) : (_vm.isLoading) ? _c('loading') : _vm._e(), _c('div', {
    staticClass: "documentos-importantes"
  }, [_c('div', {
    staticClass: "p-10 pt-20"
  }, [_c('ol', _vm._l((_vm.lista), function(o, index) {
    return _c('li', {
      staticClass: "cursor-pointer text-left transition-quick",
      class: {
        selected: o.id === _vm.idSeleccionado
      },
      on: {
        "click": function($event) {
          return _vm.seleccionar(o)
        }
      }
    }, [_c('span', [_vm._v(_vm._s(o.descripcion))])])
  }), 0)]), _c('div', {
    staticClass: "flex-1 p-10 height-calculado"
  }, [(!_vm.rutaSeleccionada) ? _c('div', {
    staticClass: "article message is-info margin-top-10 w-fit margin-auto"
  }, [_vm._m(1)]) : _vm._e(), _c('iframe', {
    staticClass: "full-width height-100",
    attrs: {
      "src": _vm.rutaSeleccionada
    }
  }, [_vm._v("Oops! an error has occurred.")])])])], 1)])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "message is-warning"
  }, [_c('div', {
    staticClass: "message-body"
  }, [_vm._v("No hay documentos importantes ingresados")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    staticClass: "message-body"
  }, [_c('span', [_vm._v("No ha seleccionado ningún documento")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-78fd7715","hasScoped":true}!./~/vue-loader/lib/template-compiler/preprocessor.js?engine=pug!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/View_Documentos_Importantes.vue
// module id = 842
// module chunks = 0